import { useNavigate } from "react-router-dom";
import "./CarrerSection.css";
import {
  FaLaptopCode,
  FaGlobe,
  FaServer,
  FaRobot,
  FaChartLine,
  FaMobileAlt,
} from "react-icons/fa";

const careers = [
  {
    id: 1,
    icon: <FaLaptopCode />,
    title: "Software Developer",
    description: "Design, develop and maintain software applications.",
  },
  {
    id: 2,
    icon: <FaGlobe />,
    title: "Frontend Developer",
    description: "Build responsive and interactive web interfaces.",
  },
  {
    id: 3,
    icon: <FaServer />,
    title: "Backend Developer",
    description: "Develop APIs, databases and server-side applications.",
  },
  {
    id: 4,
    icon: <FaRobot />,
    title: "AI Engineer",
    description: "Create Artificial Intelligence and Machine Learning models.",
  },
  {
    id: 5,
    icon: <FaChartLine />,
    title: "Data Scientist",
    description: "Analyze data and generate valuable business insights.",
  },
  {
    id: 6,
    icon: <FaMobileAlt />,
    title: "Mobile App Developer",
    description: "Develop Android and iOS mobile applications.",
  },
];

function CareerSection() {
  const navigate = useNavigate();
  return (
    <div id="student-career" className="student-page-carrersection" data-aos="fade-up" data-aos-duration="700">
      <div className="student-page-carrersection-header">
        <h2>Career Opportunities</h2>
        <p>Explore career paths after completing your course.</p>
      </div>

      <div className="student-page-carrersection-grid">
        {careers.map((career, index) => (
          <div
            className="student-page-carrersection-card"
            key={career.id}
   
          >
            <div className="student-page-carrersection-icon">{career.icon}</div>
            <h3>{career.title}</h3>
            <p>{career.description}</p>
            <button type="button" className="student-page-carrersection-button" onClick={() => navigate("/career")}>Learn More</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CareerSection;
